import { Button, Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import warningIcon from 'assets/images/modal-error.svg'

function WarningModal({
	show,
	onHide,
	...otherProps
}) {
	const { t } = useTranslation()

	return (
		<BaseModal show={show} onHide={onHide} hideDecor={true} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					<img src={warningIcon} alt="" />
				</Modal.Header>
				<Modal.Body>
					<p
						className="text-center"
						style={{
							fontWeight: 500,
							fontSize: '17px',
							lineHeight: '24px',
							color: '#B1B5C3',
						}}
					>
						{t("modal.warning.text-update")}
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={onHide}>
						{t('modal.btn.ok')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}

export default WarningModal
